// import React from 'react'
import { Row, Col } from 'reactstrap'
import { IconAperture } from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { staticAssetsPath } from '../../configs/constants'
import { useSasToken } from '../../_hooks/useSasToken'
import { Button } from 'dsm-react-lib'

export const StyledRow = styled(Row)`
  margin-top: 60px;
`

const NoResults = ({ title, url, btnText }) => {
  const { appendToken } = useSasToken()
  return (
    <>
      <StyledRow>
        <Col>
          <div className="text-center pt-4">
            <h2 className="pb-2 theme-text-heading">{title}</h2>
            {btnText !== '' && (
              <Link to={url} className="d-flex justify-content-center">
                <Button
                  label={btnText}
                  variant="outline"
                  color="secondary"
                  icon={<IconAperture size={14} />}
                  className="m-1"
                  iconOnly={false}
                  data-testid="exploreAppsBtn"
                />
              </Link>
            )}
          </div>
        </Col>
      </StyledRow>
      <Row>
        <Col>
          <div className="text-center pt-4">
            <img
              className="mr-1"
              src={appendToken(`${staticAssetsPath}/images/pages/workspace/workspace_empty.png`)}
              alt="empty_workspace"
              height="345"
            />
          </div>
        </Col>
      </Row>
    </>
  )
}
export default NoResults
